import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import MainLayout from "@/components/layout/MainLayout";
import NuumaLanding from "@/pages/NuumaLanding";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import LegalNotice from "@/pages/LegalNotice";
import CookiePolicy from "@/pages/CookiePolicy";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<MainLayout />}>
            <Route path="/" element={<NuumaLanding />} />
            <Route path="/polityka-prywatnosci" element={<PrivacyPolicy />} />
            <Route path="/informacje-prawne" element={<LegalNotice />} />
            <Route path="/polityka-cookies" element={<CookiePolicy />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Montserrat, Segoe UI, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
